import { useEffect, useState } from "react";
import api from "../api/axiosInstance";
import { shippingStatus } from "../utils/shippingStatus";

/**
 * The logged-in store's shipping setup (utils/shippingStatus.js), from its
 * store info. "unknown" for other accounts, while loading, or when the
 * request fails.
 */
export default function useShippingStatus() {
    const [store, setStore] = useState(null);

    useEffect(() => {
        const businessId = localStorage.getItem("business_id");
        if (!businessId || localStorage.getItem("signup") !== "user") return undefined;
        let live = true;
        Promise.resolve(api.get("/business/store/info", { params: { business_id: businessId } }))
            .then((res) => {
                if (live && res && res.data && res.data.status === "success") setStore(res.data.result);
            })
            .catch(() => {});
        return () => {
            live = false;
        };
    }, []);

    return shippingStatus(store);
}
